export default {
    message: {
        currencySymbol: "$",
        currencyDesc: "USD",
        product: "Citrix Secure Workspace",
        tiers: {
            t1: {
                label: "Stand-alone",
                cost: "5",
                desc: "<p>Unified access to all virtual, web and SaaS apps, Protects users, apps and data with end-to-end contextual security controls.</p><p>Provides VPN-less proxy and SSO to web, SaaS, virtual and mobile apps, as well as protection against malicious content, keyloggers, and screen capturing malware.</p>"
            },
            t2: {
                label: "Workspace Premium",
                cost: "18",
                desc: "<p>Complete workspace solution for workers who need a full digital workspace with granular security but don't require virtual apps and desktops.</p><p>Includes Workspace Standard functionality, plus advanced security controls for SaaS and web, unified endpoint management, and Content Collaboration Premium.</p>"
            },
            t3: {
                label: "Workspace Premium Plus",
                cost: "25",
                desc: "<p>Comprehensive workspace solution inclusive of hybrid deployment options for Citrix Virtual Apps and Desktops.</p><p>Includes Workspace Premium functionality, plus a cloud management option for Citrix Virtual Apps and Desktops.</p>"
            }
        },
        calculator: {
            btn1_link: "/products/citrix-secure-workspace-access/form/inquiry/"
        }
    }
}